import * as actionTypes from '../actionTypes';

export const actionCreators = {

    setSignalRConnectionStatus: isConnected => dispatch => {
        dispatch({ type: actionTypes.setSignalRConnectionStatus, isConnected });
    }

}